import { Redirect, useLocation } from 'react-router';

/**
 * Catch-all redirect that forwards the current `location.search` so external
 * deep-links like `/?settings=billing` (Stripe success/cancel URLs) survive
 * the trip to the default route. Without preserving search, post-checkout
 * redirects land on the default route with the param stripped.
 */
export default function RedirectPreservingSearch({ to }: { to: string }) {
  const location = useLocation();
  return <Redirect to={{ pathname: to, search: location.search }} />;
}
